/* DiffFoldingRules.js */

const _ = require("lodash");

define(function (require, exports) {
    const oop = ace.require("ace/lib/oop");
    const Range = ace.require("ace/range").Range;
    const BaseFoldMode = ace.require("ace/mode/folding/fold_mode").FoldMode;

    const DiffFoldMode = (exports.DiffFoldMode = function (
        markers,
        sideBySideView = true,
        isLeftEditor = true
    ) {
        this._markers = markers ? markers : [];
        this._sideBySideView = sideBySideView;
        this._isLeftEditor = isLeftEditor;
        this._distanceFromChangedLines = 3;
    });
    oop.inherits(DiffFoldMode, BaseFoldMode);

    (function () {
        this.getFoldWidget = function (session, foldStyle, row) {
            let foldWidget = undefined; //BaseFoldMode.prototype.getFoldWidget.call(this, session, foldStyle, row);
            if (foldWidget || _.isEmpty(this._markers)) {
                return foldWidget;
            }
            let foldEndRow = this._sideBySideView
                ? this._foldEndRowSideBySideView(session, foldStyle, row)
                : this._foldEndRowSinglePaneView(session, foldStyle, row);
            return foldEndRow ? "start" : "";
        };

        this.getFoldWidgetRange = function (session, foldStyle, row) {
            let foldWidgetRange = undefined; //BaseFoldMode.prototype.getFoldWidgetRange.call(this, session, foldStyle, row);
            if (foldWidgetRange || _.isEmpty(this._markers)) {
                return foldWidgetRange;
            }
            let foldEndRow = this._sideBySideView
                ? this._foldEndRowSideBySideView(session, foldStyle, row)
                : this._foldEndRowSinglePaneView(session, foldStyle, row);
            if (foldEndRow) {
                let range = new Range(row, 0, foldEndRow, session.getLine(foldEndRow).length);
                return range;
            } else {
                return null;
            }
        };

        this._foldEndRowSideBySideView = function (session, foldStyle, row) {
            let startOfFold = this._distanceFromChangedLines - 1;
            let elementToCompare = this._isLeftEditor
                ? {left: {range: {end: {row: row}}}}
                : {right: {range: {end: {row: row}}}};
            let compareProperty = this._isLeftEditor ? "left.range.end.row" : "right.range.end.row";
            let currentRowIndexInMarkers = _.sortedLastIndexBy(
                this._markers,
                elementToCompare,
                compareProperty
            );
            let previousMarkers = undefined;
            let currentRowIsChanged = false;
            if (currentRowIndexInMarkers > 0) {
                previousMarkers = this._markers[currentRowIndexInMarkers - 1];
                let previousMarkerRangeToCompare = this._isLeftEditor
                    ? previousMarkers.left.range
                    : previousMarkers.right.range;
                startOfFold = previousMarkerRangeToCompare.end.row + this._distanceFromChangedLines;
                if (
                    (previousMarkers.left.clazz === "added-line" && this._isLeftEditor) ||
                    (previousMarkers.right.clazz === "removed-line" && !this._isLeftEditor)
                ) {
                    startOfFold = startOfFold - 1;
                }
                currentRowIsChanged =
                    previousMarkerRangeToCompare.contains(row, 0) ||
                    previousMarkerRangeToCompare.start.row === row;
            }
            if (!currentRowIsChanged && startOfFold === row) {
                let afterMarkers, afterMarkersRangeToCompare;
                let rowBeforeNextMarker = session.getLength() - 2;
                let isRowChanged = false;
                if (currentRowIndexInMarkers <= this._markers.length - 1) {
                    afterMarkers = this._markers[currentRowIndexInMarkers];
                    afterMarkersRangeToCompare = this._isLeftEditor
                        ? afterMarkers.left.range
                        : afterMarkers.right.range;
                    rowBeforeNextMarker = afterMarkersRangeToCompare.start.row - 1;
                    isRowChanged =
                        afterMarkersRangeToCompare.contains(row, 0) ||
                        afterMarkersRangeToCompare.start.row === row;
                }
                if (!isRowChanged && rowBeforeNextMarker - row > this._distanceFromChangedLines) {
                    let endOfFoldRow = rowBeforeNextMarker - this._distanceFromChangedLines;
                    return endOfFoldRow;
                }
            }
            return "";
        };

        this._foldEndRowSinglePaneView = function (session, foldStyle, row) {
            let startOfFold = this._distanceFromChangedLines - 1;
            let elementToCompare = {
                left: {range: {end: {row: row}}},
                right: {range: {end: {row: row}}},
            };
            //let compareProperty = this._isLeftEditor ? 'left.range.end.row' : 'right.range.end.row';
            let currentRowIndexInMarkers = _.sortedLastIndexBy(
                this._markers,
                elementToCompare,
                function (element) {
                    let compareProp = _.has(element, "left.range.end.row")
                        ? "left.range.end.row"
                        : "right.range.end.row";
                    return _.get(element, compareProp);
                }
            );
            let previousMarkers = undefined;
            let currentRowIsChanged = false;
            if (currentRowIndexInMarkers > 0) {
                previousMarkers = this._markers[currentRowIndexInMarkers - 1];
                let previousMarkerRangeToCompare = previousMarkers.right
                    ? previousMarkers.right.range
                    : previousMarkers.left.range;
                startOfFold = previousMarkerRangeToCompare.end.row + this._distanceFromChangedLines;
                currentRowIsChanged =
                    previousMarkerRangeToCompare.contains(row, 0) ||
                    previousMarkerRangeToCompare.start.row === row;
            }
            if (!currentRowIsChanged && startOfFold === row) {
                let afterMarkers, afterMarkersRangeToCompare;
                let rowBeforeNextMarker = session.getLength() - 2;
                let isRowChanged = false;
                if (currentRowIndexInMarkers <= this._markers.length - 1) {
                    afterMarkers = this._markers[currentRowIndexInMarkers];
                    afterMarkersRangeToCompare = afterMarkers.left
                        ? afterMarkers.left.range
                        : afterMarkers.right.range;
                    if (afterMarkers.left !== undefined && afterMarkers.right !== undefined) {
                        afterMarkersRangeToCompare = new (ace.require("ace/range").Range)(
                            afterMarkers.left.range.start.row,
                            0,
                            afterMarkers.right.range.end.row,
                            0
                        );
                    }
                    rowBeforeNextMarker = afterMarkersRangeToCompare.start.row - 1;
                    isRowChanged =
                        afterMarkersRangeToCompare.contains(row, 0) ||
                        afterMarkersRangeToCompare.start.row === row;
                }
                if (!isRowChanged && rowBeforeNextMarker - row > this._distanceFromChangedLines) {
                    let endOfFoldRow = rowBeforeNextMarker - this._distanceFromChangedLines;
                    return endOfFoldRow;
                }
            }
            return "";
        };

        this.setMarkers = function (markers) {
            this._markers = markers;
        };

        this.setSideBySideView = function (sideBySideView) {
            this._sideBySideView = sideBySideView;
        };
    }).call(DiffFoldMode.prototype);
});
